// extracted by mini-css-extract-plugin
export var card = "_p5-0";
export var content = "_p5-2";
export var details = "_p5-3";
export var icon = "_p5-1";
export var iconBlue = "_p5-5";
export var iconBrand = "_p5-4";
export var iconGrayBlue = "_p5-6";
export var iconGreen = "_p5-7";
export var iconIndigo = "_p5-8";
export var iconOrange = "_p5-9";
export var iconPurple = "_p5-a";
export var iconRed = "_p5-b";
export var iconWarning = "_p5-c";